import confetti from "canvas-confetti";

export function doughBurst(x, y) {
  const origin = {
    x: x / window.innerWidth,
    y: y / window.innerHeight,
  };
  confetti({
    particleCount: 45,
    spread: 60,
    startVelocity: 32,
    scalar: 0.9,
    origin,
    colors: ["#FF5003", "#0C4A28", "#FFFDF8", "#E8B04B"],
    ticks: 120,
  });
}
